import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import CartDrawer from '../components/CartDrawer';
import FloatingActions from '../components/FloatingActions';
import Footer from '../components/Footer';
import CmsSection from '../cms/CmsSection';
import { useCmsSections } from '../cms/useCms';

const HomePage: React.FC = () => {
  const { i18n } = useTranslation();
  const [isCartOpen, setIsCartOpen] = useState(false);
  const { sections, loading } = useCmsSections();
  const footerSection = sections.find((s) => s.key === 'footer');

  useEffect(() => {
    if (!i18n.language) {
      i18n.changeLanguage('zh-HK');
    }
  }, [i18n]);

  return (
    <div className="min-h-screen bg-brand-paper selection:bg-brand-cinnabar/30 selection:text-brand-ink">
      <Header onOpenCart={() => setIsCartOpen(true)} />

      <main>
        {loading ? (
          <div className="min-h-[60vh] flex items-center justify-center text-brand-ink/50">
            <div className="text-center">
              <div className="w-10 h-10 border-2 border-brand-gold/30 border-t-brand-cinnabar rounded-full animate-spin mx-auto mb-4" />
              <p className="font-sans text-sm tracking-widest">載入中…</p>
            </div>
          </div>
        ) : (
          sections
            .filter((s) => s.isActive && s.key !== 'footer')
            .sort((a, b) => a.sortOrder - b.sortOrder)
            .map((section) => <CmsSection key={section.key} section={section} />)
        )}
      </main>

      {!loading && <Footer content={footerSection?.contentJson || {}} />}

      <CartDrawer isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
      <FloatingActions />
    </div>
  );
};

export default HomePage;
